import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { formatCurrency } from "../../formatters/formatCurrency";
export const FormatCurrency = (props)=>{
    const formattedValue = formatCurrency(props.value, props.options);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: formattedValue
    });
};
FormatCurrency.displayName = 'FormatCurrency';

//# sourceMappingURL=FormatCurrency.js.map